import http from '@/plugins/http';
import { useAccountStore } from '@/stores/account';
import snakeToCamel from '../../utils/snakeToCamel';

export default () => new Promise((res, rej) => {
  http.get('/v3/permissions')
    .then((response) => {
      const perms = response.data.reduce((total, perm) => {
        total[snakeToCamel(perm.id)] = perm.result;
        return total;
      }, {});
      useAccountStore().Permissions(perms);
      res(perms);
    })
    .catch((error) => {
      rej(error);
    });
});
